/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';

const imageContainerCss = css`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  margin-left: -20px;
  position: relative;
`;

const imageCss = css({
  svg: {
    height: '100%', // Change this to adjust the vertical alignment of the image.
  },
});

export const AutoUpgradeNudgeImage = () => {
  const ImageSvg = require(`./images/AutoUpgradeNudgeImage`).default;

  return (
    <div css={[imageContainerCss, imageCss]}>
      <ImageSvg />
    </div>
  );
};
